import { getDocument } from '@/helpers/globals'
import { useUtmParams } from './useUtmParams'

import { useMsClarity } from '@/third-party/clarity.ts'
import { useAhrefs } from '@/third-party/ahrefs'
import { useAttributionParams } from '@/composables/app/gtm/useAttributionParams'

export function useAnalytics(): void {
    useAttributionParams()

    const document = getDocument()

    if (import.meta.env.SSR || import.meta.env.DEV || !document) {
        return
    }

    useUtmParams()

    useMsClarity()

    useAhrefs()
}
